import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Badge } from "../badges.interface";
import { Image } from "../../image-uploader/image.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../error-state-matcher";

@Component({
  selector: "app-badges-dialog",
  templateUrl: "./badges-dialog.component.html",
  styleUrls: ["./badges-dialog.component.scss"],
  standalone: false,
})
export class BadgesDialogComponent {
  form: FormGroup;
  previewUrl: string | null = null;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<BadgesDialogComponent>,
  ) {
    const requiredValidator = (c: AbstractControl) => Validators.required(c);
    this.form = this.fb.group({
      label: ["", requiredValidator],
      description: [""],
      image: [null, requiredValidator],
    });
  }

  onFileChange(result: Image): void {
    this.form.patchValue({ image: result.file });
    this.previewUrl = result.previewUrl ?? null;
  }

  removeImage(): void {
    this.previewUrl = null;
    this.form.patchValue({ image: null });
  }

  save(): void {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    const { label, description } = this.form.value as {
      label: string;
      description: string;
    };
    const badge: Badge = {
      label,
      description: description || undefined,
      url: this.previewUrl || "",
    };
    this.dialogRef.close(badge);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
